import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './emailInput.html?raw';
import "../../../moreCore/UI/Container/ExpandableSectionTypes";
import { EmailEditorTypes } from "../emailTypes";
import on from 'dojo/on';
import emailSuggestion from '../emailSuggestion/emailSuggestion';
import _LabelInputBase from '../../../moreCore/UI/_LabelInputBase/_LabelInputBase';


interface mailRecipientReg extends EmailEditorTypes.mailRecipient {
    buttonNode: HTMLElement;
}
class emailRecipientInput extends compose(_LabelInputBase) {
    templateString: any = template;

    //#region button template
    //emailButtonTemplateString = "<button class=\"mds-button-base round hoverBright secondaryBG w3-small\" style=\"margin: 2px; display: flex; justify-content: center; align-items: center;\"><i class=\"far fa-user-circle\" style=\"padding:5.5px\"></i> {insertHere}</button>";


    private rowContainer: HTMLElement;
    private inputContainer: HTMLElement;
    private inputBox: HTMLInputElement;
    private emailDisplayButtonRow: HTMLDivElement;
    private searchButton: HTMLButtonElement;

    private emailSuggestionPopup: MdsLax<InstanceType<typeof emailSuggestion>> = null;


    private recipients: Array<mailRecipientReg> = [];
    private recipientsString = ""; //gefilterten mails


    private regexFunc: any = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    //#region options/attr
    disableSearchButton = false;
    alwaysShowSearchButton = true;
    disableValidation = false;
    enableMultiMailInput = true;
    //isReadonly = false;
    maxLength: number = 524288; // default of 512KB
    // .....

    splitChars: any = [";", ","]; // splitChars[0] wird fuer default formatierungen verwendet

    //#region misc. flags

    //siehe setValue()
    blockValueEmit = false; //workaround weil ansonten feedback-loop

    //siehe focusOutInputCheck()
    private enableUXmailbuttonHelper = true; // interne flag zum dissablen

    private mailFormContext: EmailEditorTypes.mailFormContext;

    // siehe inputboxKeyHanlder()
    lastKeyWasBackspace = false;

    public setMailFormContext(mailFormContext: EmailEditorTypes.mailFormContext) {
        this.mailFormContext = mailFormContext;

        this.mailFormContext = mailFormContext;
    }

    

    private _onFocusIn_Input(evt) {
        if (this.isReadonly) return;
        this.isFocused = true;
        this.UiModder.domClass.add(this.rowContainer, "focus");
    }


    //#region Input focusOut

    // soll nur auf True gesetzt werden wenn der user folgendes gemacht hat:
    // - beim ersten mal Triggern der focusOut funktion
    // - beim triggeren der swap methode durch druecken von "Enter" oder splitChar input
    //#region focusOutInputChk
    private _onBlur_Input() {
        this.isFocused = false;

        if (this.isReadonly) return;

        this.handleInputContent();
    }
    private _onFocusOut_Input() {
        this.UiModder.domClass.remove(this.rowContainer, "focus");

        if (this.isReadonly) return;

        this.handleInputContent();
        return;

       
    }
    private _onInput_Input(evt: InputEvent) {
        if (this.isReadonly) return;

        // clear values
    //    this.inputCurrentlyCapturing = false;

    //    if (this.lastKeyWasBackspace === false) {
    //        this.handleInputContent();
    //    }
    }
    private getInputSplits(): Array<string> {
        let newInputValue = this.inputBox.value; //(evt.target as HTMLInputElement).value;
        // cleanup von spaces
        newInputValue = newInputValue.split(" ").join(""); // replace " " mit ""
        // string cleanup von "," ";"
        for (let splitter of this.splitChars) {
            if (newInputValue.slice(-1) === splitter) {
                // der letzte getippte Wert ist einer der Splitter. also können wir den Input gleich umwandeln:
                newInputValue = newInputValue.substring(0, newInputValue.length - 1);
            }
        }

        // splittet auf, falls mehrere Mails vorhanden sind
        let wasSplit = false;
        let splitValues: Array<string> = [newInputValue];
        for (let splitter of this.splitChars) {
            let placeholderarray: Array<string> = [];
            for (let currentArrayElement of splitValues) {
                if (currentArrayElement.search(splitter) !== (-1)) {
                    for (let subsplit of currentArrayElement.split(splitter)) {
                        if (subsplit) {
                            placeholderarray.push(subsplit);
                        }
                    }
                    wasSplit = true;
                } else {
                    placeholderarray.push(currentArrayElement);
                }
            }
            splitValues = placeholderarray;
        }

        if (wasSplit === false) {
            splitValues = [newInputValue];
        }

        if (this.disableValidation === false) {

        }

        return splitValues;
    }
    private handleInputContent(suppressChangeEvent?: boolean) {

        

        let splitValues: Array<string> = this.getInputSplits();
        let invalidValues: Array<string> = [];
        let triggerInputSwap = splitValues.length > 0;
      
        // Regex-Validation
        if (this.disableValidation == false) {


            // regex validation
            let validValues: Array<string> = [];
            for (let checkValue of splitValues) {
                let captures = checkValue.match(this.regexFunc);
                if (captures !== null) {
                    validValues.push(captures[0]);
                } else {
                    invalidValues.push(checkValue);
                }
            }

            splitValues = validValues;
        }
       

        if (triggerInputSwap) {
            //this.inputBox.value = invalidValues.join(";");
            this.addRecipients(splitValues, suppressChangeEvent);
        }

        this.validateInput();

        //console.debug(this.id + "handleInputContent", this.getValue());
    }

    //#region inputKeyHandler
    private _onKeyDown_Input(ev: KeyboardEvent) {
        if (this.inputBox.classList.contains("emailAdresseInputBoxHideHint") === false) {
            this.inputBox.classList.add("emailAdresseInputBoxHideHint"); //versteckt den hint in der input box
        }
        // wenn Enter gedrueckt wird UND die regex funktion ausschlaegt, wird die func getriggered
        if (ev.key == "Backspace") {
            if (this.inputBox.value) {
                this.lastKeyWasBackspace = true;
            } else {
                // holt den letzten mailbutton raus
                if (this.recipients.length >= 1) {
                    this.swapMailButtonToInput(this.recipients[this.recipients.length - 1]);
                    this.inputBox.value = this.inputBox.value + " "; // damit man nicht sofort den mailButton inhalt weck-loescht
                }
            }
            return;
        } else {
            this.lastKeyWasBackspace = false;
        }
        if (ev.key == "Enter") {
            //if (this.disableValidation) {
            //    this.swapInputToMailButton();
            //    return;
            //}
            //this._onInput_Input(null);
            this.handleInputContent();
            //if (this.inputCurrentlyCapturing) {
            //    this.swapInputToMailButton();
            //}
        }
    }

    private getRecipientByMailaddress(mailaddress: string): EmailEditorTypes.mailRecipient {
        if (!mailaddress) return null;

        for (let rec of this.recipients) {
            if (rec.mailaddress.toLocaleLowerCase() == mailaddress.toLocaleLowerCase()) {
                return rec;
            }
        }

        return null;
    }

    //#region swap2mailbutton
    addRecipients(valuelist: Array<string | EmailEditorTypes.mailRecipient>, suppressChangeEmit?: boolean) {
        //this.inputBox.value = ""; // clear inputbox
        if (!valuelist?.length) return;
        let inputValue = this.inputBox.value;
        for (let entry of valuelist) {

            let mailStr: string = null;
            let entityID = null;
            if (typeof (entry) == "string") {
                mailStr = entry;
            } else if (entry && typeof (entry) == "object") {
                mailStr = entry.mailaddress;
                entityID = entry.entityID;
            }
            if (this.getRecipientByMailaddress(mailStr) == null) {
                let newRec: mailRecipientReg = {
                    entityID: entityID,
                    mailaddress: mailStr,
                    buttonNode: null
                };

                this.recipients.push(newRec);
                this.recipientsString += mailStr + ";";

            }

            let count = 0;
            while (inputValue.search(mailStr) != -1) {
                inputValue = inputValue.replace(mailStr, "");

                count++;
                if (count > 999) break;
            }
        }

        // falls im verbleibenden String jetzt irgendwo unnötige Splitter stehen, diese bereinigen:
        // zb abc@xyz.com;;testtest;;xx -> abc@xyz.com;testtest;xx
        for (let splitter of this.splitChars) {
            let result = 0;
            let count = 0;
            while (result != -1) {
                result = inputValue.search(splitter + splitter);

                if (result != -1) {
                    inputValue = inputValue.replace(splitter + splitter, splitter);
                }

                count++;
                if (count > 999) break;
            }
        }
        // leftovers zum input
        this.inputBox.value = inputValue;
        
        // schreibt die Buttons in den DOM
        this.drawRecipientButtons();
        // reset var
        this.lastKeyWasBackspace = false;

        this.updateInternalValues(suppressChangeEmit);
    }

    private updateInternalValues(suppressChangeEmit?: boolean) {
        this._value = this.recipientsString;
        this.validateInput();


        if (!suppressChangeEmit) {
            this.__delayValueChangeEmit();
        }

    }

    //#region render buttons
    private drawRecipientButtons() {
        //let newButtonRow = "";
        //for (let emailListElement of this.recipients) {
        //    let templateStringForButton = this.emailButtonTemplateString.slice(0, this.emailButtonTemplateString.length); //deepcopy attempt
        //    newButtonRow = newButtonRow + templateStringForButton.replace("{insertHere}", (emailListElement as string));
        //}
        //this.destroyButtonRow();
        //this.emailDisplayButtonRow.innerHTML = newButtonRow;

        this.UiModder.domConstruct.empty(this.emailDisplayButtonRow);

        for (let recipient of this.recipients) {
            let btn = this.UiModder.domConstruct.create("button", {
                className: "recipient mds-button-base",
                innerHTML: recipient.mailaddress
            }, this.emailDisplayButtonRow);

            this.UiModder.domClass.toggle(btn, "secondaryBG hoverBright", !this.isReadonly);
            this.UiModder.domClass.toggle(btn, "tertiaryBG", this.isReadonly);

            recipient.buttonNode = btn;

            if (this.isReadonly) {
                //this.disableNode(btn);
            } else {
                on(btn, "click", lang.hitch(this, this._onClick_RecipientButton, recipient));
            }
        }

        this.hideNode(this.emailDisplayButtonRow, this.recipients.length == 0);
        this._handleSearchButtonVisibility();

        
    }

    //#region emailButtonClick
    private _onClick_ButtonsRow(evt: MouseEvent) {
        if (this.isReadonly) return;
        evt.preventDefault();
        evt.stopPropagation();
        this.inputBox.focus();
    }
    private _onClick_RecipientButton(recipient: mailRecipientReg, ev: MouseEvent) {
        if (this.isReadonly == true) {
            return;
        }
        ev.preventDefault();
        ev.stopPropagation();
        //targetMail = targetMail.slice(0, targetMail.length); // entfernt space auf position 0, weil siehe Button Template String
        //entferne den array entry + button
        this.swapMailButtonToInput(recipient);
    }
    //#region swapButton2Input
    private swapMailButtonToInput(recipient: mailRecipientReg) {

        if (!recipient) return;
        let mailTxt = recipient.mailaddress;

        for (let i = 0; i < this.recipients.length; i++) {
            let testRep = this.recipients[i];

            if (testRep.mailaddress.toLowerCase() == recipient.mailaddress.toLowerCase() && testRep.entityID == recipient.entityID) {
                this.recipients.splice(i, 1);
            }
        }

        this.recipientsString = this.recipients.join(this.splitChars[0]);
        
        //this.emitValue();
        this.drawRecipientButtons();

        this.updateInternalValues();
        //fuegt das entfernte element in die input box ein
        if (!this.inputBox.value) {
            this.inputBox.value = mailTxt;
        } else {
            this.inputBox.value += this.splitChars[0] + mailTxt;
        }

        this.inputBox.focus();
    }
    //#region destroyButtonRow
    //private destroyButtonRow() {
    //    //remove click event
    //    for (let i = 0; i < this.emailDisplayButtonRow.children.length; i++) {
    //        (this.emailDisplayButtonRow.children[i] as HTMLButtonElement).removeEventListener("click", this._onClick_RecipientButton);
    //    }
    //    this.emailDisplayButtonRow.innerHTML = "";
    //     //shows the search button again
    //    this.searchButtonShow();
    //}


    private _handleSearchButtonVisibility() {

        this.hideNode(this.searchButton);

        if (this.hasFeature("Email_Editor", "Suggestions") == false) {
            this.searchButton.disabled = true;
            return;
        }

        if (this.isReadonly) return;

        this.UiModder.domClass.toggle(this.searchButton, "w3-hide-small", this.recipients.length > 0);

        if (this.disableSearchButton) {

            //this.inputBox.style.borderLeft = "solid 1px";
            //this.inputBox.style.borderLeftColor = "rgb(175, 175, 179)";
            return;
        }


        if (this.alwaysShowSearchButton == true) {
            this.hideNode(this.searchButton, false);
        }

    }

    /**
     * Input ist hier nicht ausschlaggebend für den tatsächlichen Wert!!
     * @param newValue
     * @param suppressChangeEmit
     */
    protected setInputValue(newValue, suppressChangeEmit?: boolean) {
        this.inputBox.value = newValue;

        this.handleInputContent(suppressChangeEmit);
    }
    //#region setValue
    public setValue(newValue: Array<string | EmailEditorTypes.mailRecipient>, suppressChangeEmit?: boolean) {

        this.recipients = [];
        this.recipientsString = "";
        this._value = "";

        this.setInputValue(null, true); // nicht emitten, erst mal ausleeren!
        if (newValue?.length) {
            this.addRecipients(newValue, suppressChangeEmit);
        } else {
            this.drawRecipientButtons();
        }

        
    }
    public getValue(returnAsString?: boolean): Array<EmailEditorTypes.mailRecipient> | Array<string> {
        if (returnAsString == true) return this.recipientsString.split(";");

        let result: Array<EmailEditorTypes.mailRecipient> = [];
        for (let addr of this.recipients) {
            result.push({ entityID: addr.entityID, mailaddress: addr.mailaddress });
        }

        return result;
    }
    
    //public emitValue() {
    //    let emitVal = this.recipientsString;
    //    if (emitVal === null) {
    //        emitVal = "";
    //    }
    //    if (typeof emitVal === 'undefined') {
    //        emitVal = "";
    //    }
    //    if (this.blockValueEmit === false) {
    //        this.emit("valueChange", emitVal);
    //    }
    //}

    private _onClick_SearchButton(evt) {
        //#region search button popup
        if (!this.emailSuggestionPopup) {
            this.emailSuggestionPopup = new emailSuggestion(this.mailFormContext);
            this.emailSuggestionPopup.on("select", lang.hitch(this, this._onHandle_MailSuggestions));
        }

        this.emailSuggestionPopup.setMailFormContext(this.mailFormContext);
        this.emailSuggestionPopup.setExcludedMails(this.recipients.map(entry => entry.mailaddress));


        if (document.activeElement != document.body) {
            //entfernt den focus vom geclickten button, da man ansonsten popups spamen könnte
            try {
                //@ts-expect-error
                document.activeElement.blur();
            } catch {/*elemnt hat kein blur()*/ }
        }
        this.emailSuggestionPopup.openDlg(evt);
    }

    //#region handle suggestin
    private _onHandle_MailSuggestions(recipients: Array<EmailEditorTypes.mailRecipient>) {
        if (!recipients?.length) return;

        this.addRecipients(recipients);
    }



    //#region attr get&set
    private _setAlwaysShowSearchButtonAttr(newValue: boolean) {

        if (newValue === true || newValue === false) {
            this.alwaysShowSearchButton = newValue;
        }

        this._handleSearchButtonVisibility();
    }

    //// set Label anhand von data-dojo-props
    //_setLabelAttr(newValue: string) {
    //    if ((newValue == null) && (typeof newValue === 'undefined')) {
    //        this.labelNode.innerText = "";
    //    }
    //    this.labelNode.innerText = newValue;
    //}

    private _setSearchButtonEnabledAttr(newValue: boolean) {

        if (newValue === true || newValue === false) {
            this.disableSearchButton = !newValue;
        }

        this._handleSearchButtonVisibility();

    }

    private _setDisableValidationAttr(newValue: boolean) {
        
        if (newValue === true || newValue === false) {
            this.disableValidation = newValue;
        }
    }
    

    private _setAllowMultiMailInputAttr(newValue: boolean) {

        if (newValue === true || newValue === false) {
            this.enableMultiMailInput = newValue;
        }
    }

    protected customValidation(): boolean {
        return super.customValidation.apply(this, arguments as any);
    }

    protected _setReadonlyStyle() {
        
        this._handleSearchButtonVisibility();

        this.inputBox.readOnly = this.isReadonly;
        //this.disableNode(this.rowContainer, this.isReadonly);
        this.disableNode(this.inputContainer, this.isReadonly);

        this.drawRecipientButtons();
    }

    private _setMaxLengthAttr(newValue: string) {
        if ((newValue == null) && (typeof newValue === 'undefined')) {
            this.maxLength = 524288;
            return;
        }
        if (isNaN(Number(newValue))) {
            this.maxLength = 524288;
            return;
        }
        this.maxLength = Number(newValue);
        this.inputBox.maxLength = Number(newValue);
    }

    //#region postCreate
    postCreate(): void {

        this.recipients = [];
        this.recipientsString = "";

        if (this.splitChars.length === 0) {
            this.splitChars = [",", ";"]; //overwrite, damit ja nichts zerbricht
        }

        this.hideNode(this.emailDisplayButtonRow);

        this._handleSearchButtonVisibility();

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    destroy() {
        super.destroy.apply(this, arguments as any);
    }
}

export default mdsWidget(emailRecipientInput);
